// «¿Código?» en el pie del detalle de «Elige el teléfono»: solo lo anota; Promociones lo valida al
// continuar, ya con el teléfono apartado. Si lo rechaza, el campo vuelve con el código y el motivo.
import { useState } from 'react';
import { Tag } from 'lucide-react';
import { Button } from '@/kit';
import { updatePhoneDraft } from '../hooks/usePhoneDraft';
import {
    usePromotionSelectionStore,
    useSessionPromotionState,
} from '../store/promotionSelectionStore';
import { DiscountCodeEntry } from './DiscountCodeEntry';

export interface PhoneDiscountCodeFieldProps {
    sessionId: string;
    sku: string;
    /** Venta cobrada: el código ya no se cambia. */
    disabled?: boolean;
}

export function PhoneDiscountCodeField({
    sessionId,
    sku,
    disabled = false,
}: PhoneDiscountCodeFieldProps) {
    const { phoneDraft, phoneCodeRejection } = useSessionPromotionState(sessionId);
    const patch = usePromotionSelectionStore((s) => s.patch);
    // El motivo se esconde en cuanto el vendedor corrige el texto.
    const [edited, setEdited] = useState<typeof phoneCodeRejection>(null);
    const code = phoneDraft?.sku === sku ? phoneDraft.code : null;
    const setCode = (next: string | null): void => {
        patch(sessionId, { phoneCodeRejection: null });
        updatePhoneDraft(sessionId, sku, (draft) => ({ ...draft, code: next }));
    };

    if (code) {
        return (
            <div className="flex items-center justify-between gap-2 text-[12.5px]">
                <span className="flex items-center gap-1.5">
                    <Tag className="size-3.5 text-success" aria-hidden />
                    <span>
                        Código <strong>{code}</strong>
                    </span>
                </span>
                <Button
                    variant="ghost"
                    size="sm"
                    disabled={disabled}
                    onClick={() => {
                        setCode(null);
                    }}
                >
                    Quitar
                </Button>
            </div>
        );
    }

    return (
        <DiscountCodeEntry
            key={phoneCodeRejection?.code ?? ''}
            initialText={phoneCodeRejection?.code ?? ''}
            label={
                <span className="flex h-9 flex-none items-center gap-1 text-[12.5px] text-muted-foreground">
                    <Tag className="size-3.5" aria-hidden />
                    ¿Código?
                </span>
            }
            disabled={disabled}
            error={
                phoneCodeRejection && edited !== phoneCodeRejection
                    ? phoneCodeRejection.message
                    : null
            }
            onApply={setCode}
            onEdit={() => {
                setEdited(phoneCodeRejection ?? null);
            }}
        />
    );
}
